import { combineReducers } from 'redux'
import dunning from './dunning'
import ecommerce from './e-commerce'
import deliveryConditions from './deliveryConditions'
import payConditions from './payConditions'
import extensions from './extensions'
import company from './company'
import taxAccountant from './taxAccountant'
import letterPaper from './letterPaper'
import textModules from './textModules'
import customerCenter from './customerCenter'

export default combineReducers({
  dunning,
  ecommerce,
  deliveryConditions,
  payConditions,
  extensions,
  company,
  taxAccountant,
  letterPaper,
  textModules,
  customerCenter,
})
